import React from "react";
import background  from '../Img/background.png';
import Axios from 'axios';

export class RecuperarSenha extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            senha: "",
            confirmarSenha: ""
        }
    }

    async resetarSenha(e) {
        if(this.state.email.length < 6){
            alert("Email inválido")
        }
        else if (this.state.senha.length < 6 || this.state.senha != this.state.confirmarSenha){
            alert("Senha inválida!")
        }
        else{
            try {
                var axiosInstance = new Axios.create({
                    baseURL: window.localStorage.getItem("apiUrl")
                });
                const response = await axiosInstance.post("v1/app/client/reset-password-sem-email", {email: this.state.email, senha: this.state.senha});
                alert(response.data.msg)
                response.data.msg.includes("confirmada")? window.location.href = "/" : console.log("")
            } catch (err) {
                console.log(err);
            }
        }
    }

    handlerValue(e) {
        this.setState({[e.target.name] : e.target.value})
    }

    render() {

        return (
            <div className="container"  style={{backgroundImage: `url(${background})`}}>
                <div className="content">
                    <div className="container-fluid" >
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>
                        <div className="row" style={{width: "720px", maxWidth: "100%"}}>
                                <div className="card rounded" style={{width: "100%", padding: 32, backgroundColor: "rgba(0,0,0,0.6)", border: "3px solid black", boxShadow: "12px 12px 12px black"}}>
                                    <div>
                                        <h4 style={{color: "white", fontWeight: "bolder"}}> Recuperar senha</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="form-group row">
                                            <label htmlFor="email" style={{color: "white", fontWeight: "bolder"}}>Email *</label>
                                            <input id="email" name="email" className="form-control" type="text"  placeholder="seuemail@gmail.com" onChange={this.handlerValue.bind(this)}></input>
                                        </div>
                                        <div className="form-group row">
                                            <label htmlFor="senha" style={{color: "white", fontWeight: "bolder"}}>Nova senha *</label>
                                            <input id="senha" name="senha" className="form-control" type="password" placeholder="senha" onChange={this.handlerValue.bind(this)}></input>
                                        </div>
                                        <div className="form-group row">
                                            <label htmlFor="confirmarSenha" style={{color: "white", fontWeight: "bolder"}}>Confirmar senha *</label>
                                            <input id="confirmarSenha" name="confirmarSenha" className="form-control" type="password"  placeholder="confirmar senha" onChange={this.handlerValue.bind(this)}></input>
                                        </div>
                                        <div className="row d-flex" style={{justifyContent: "space-between"}}>
                                            <button onClick={() => window.location.href = "/"}>Voltar</button>
                                            <button onClick={this.resetarSenha.bind(this)}>Confirmar</button>
                                        </div>

                                    </div>
                                </div>

                        </div>
                        </div>
                    </div>
                </div>
                </div>
        );
    }
}

export default RecuperarSenha;
